import { render, staticRenderFns } from "./ListaDeUploadDeArquivos.vue?vue&type=template&id=029eea84&scoped=true&"
import script from "./ListaDeUploadDeArquivos.vue?vue&type=script&lang=js&"
export * from "./ListaDeUploadDeArquivos.vue?vue&type=script&lang=js&"
import style0 from "./ListaDeUploadDeArquivos.vue?vue&type=style&index=0&id=029eea84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029eea84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardText,VList})
